export const menuItems = [
  {
    id: 1,
    name: 'クラシックバーガー',
    nameEn: 'Classic Burger',
    price: '¥1,280',
    description: 'ジューシーなビーフパティに、フレッシュレタスと完熟トマト、秘伝のスペシャルソースを挟んだ自慢の一品。',
    image: 'https://readdy.ai/api/search-image?query=Classic%20American%20diner%20burger%20with%20juicy%20beef%20patty%2C%20fresh%20lettuce%2C%20tomato%2C%20and%20special%20sauce%20on%20a%20toasted%20bun%2C%20served%20on%20a%20checkered%20red%20and%20white%20tablecloth%20background%2C%20warm%20vintage%20lighting%2C%20retro%20diner%20style%20food%20photography&width=600&height=600&seq=menu-burger-01&orientation=squarish',
    badge: 'BEST SELLER',
  },
  {
    id: 2,
    name: 'フルーツパンケーキ',
    nameEn: 'Fruit Pancakes',
    price: '¥980',
    description: 'ふわふわのパンケーキに季節のフレッシュフルーツとメープルシロップをたっぷりかけた甘美な逸品。',
    image: 'https://readdy.ai/api/search-image?query=Fluffy%20American%20pancakes%20stacked%20high%20with%20fresh%20strawberries%2C%20blueberries%2C%20banana%20slices%2C%20and%20drizzled%20maple%20syrup%2C%20served%20on%20a%20white%20plate%20with%20red%20and%20white%20checkered%20napkin%20background%2C%20warm%20retro%20diner%20lighting%2C%20food%20photography&width=600&height=600&seq=menu-pancake-02&orientation=squarish',
  },
  {
    id: 3,
    name: 'オールアメリカンホットドッグ',
    nameEn: 'All-American Hot Dog',
    price: '¥780',
    description: 'ぷりっとしたソーセージに、マスタード、ケチャップ、 relish をたっぷりかけた、正統派アメリカンスタイル。',
    image: 'https://readdy.ai/api/search-image?query=Classic%20American%20hot%20dog%20with%20grilled%20sausage%20in%20soft%20bun%2C%20topped%20with%20mustard%2C%20ketchup%2C%20and%20relish%2C%20served%20on%20red%20and%20white%20checkered%20paper%20background%2C%20retro%20diner%20atmosphere%20with%20warm%20lighting%2C%20appetizing%20food%20photography&width=600&height=600&seq=menu-hotdog-03&orientation=squarish',
  },
  {
    id: 4,
    name: 'ストロベリーシェイク',
    nameEn: 'Strawberry Milkshake',
    price: '¥680',
    description: '濃厚なバニラアイスと新鮮なストロベリーをブレンドした、懐かしい味わいの手作りミルクシェイク。',
    image: 'https://readdy.ai/api/search-image?query=Thick%20strawberry%20milkshake%20in%20tall%20retro%20diner%20glass%20with%20whipped%20cream%20and%20fresh%20strawberry%20on%20top%2C%20red%20and%20white%20striped%20straw%2C%20served%20on%20checkered%20tablecloth%20background%2C%20warm%20vintage%20diner%20lighting%2C%20nostalgic%20food%20photography&width=600&height=600&seq=menu-shake-04&orientation=squarish',
  },
];

export const features = [
  {
    id: 1,
    title: 'JUKEBOX',
    description: '1950年代のクラシックなジュークボックスが常設。お気に入りのレコードを選んで、レトロな雰囲気を楽しめます。',
    icon: 'ri-vip-diamond-line',
  },
  {
    id: 2,
    title: 'FREE REFILL',
    description: 'コーヒーと紅茶はおかわり自由。ゆっくりとくつろぎの時間をお過ごしください。',
    icon: 'ri-cup-line',
  },
  {
    id: 3,
    title: 'CHECKERED FLOORS',
    description: '赤白の市松柄の床とネオンサインが、まるでアメリカのロードサイドダイナーにタイムスリップしたような体験を。',
    icon: 'ri-grid-line',
  },
];

export const testimonials = [
  {
    id: 1,
    rating: 5,
    title: '街で一番のバーガー！',
    body: 'パティの肉汁がジューシーで、バンズもふわふわ。何度でも通いたくなる味です。スタッフの対応も最高でした。',
    name: '田中 健一',
    role: 'Regular Customer',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20friendly%20middle%20aged%20Japanese%20man%20with%20warm%20smile%2C%20casual%20clothing%2C%20neutral%20cream%20background%2C%20soft%20natural%20lighting%2C%20vintage%20film%20photography%20style%20with%20warm%20sepia%20tones&width=100&height=100&seq=avatar-01&orientation=squarish',
  },
  {
    id: 2,
    rating: 5,
    title: 'パンケーキが絶品',
    body: 'ふわふわの食感と季節のフルーツの組み合わせが最高。週末の朝食にぴったりの場所です。雰囲気も素敵。',
    name: '佐藤 美咲',
    role: 'Food Blogger',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Japanese%20woman%20with%20bright%20smile%20and%20stylish%20appearance%2C%20casual%20fashion%2C%20neutral%20warm%20background%2C%20soft%20natural%20lighting%2C%20vintage%20film%20photography%20style%20with%20subtle%20warm%20tones&width=100&height=100&seq=avatar-02&orientation=squarish',
  },
  {
    id: 3,
    rating: 5,
    title: 'レトロな雰囲気が最高',
    body: 'ジュークボックスの音楽と赤白の市松柄の床が、まるで映画の世界。デートにも友達とのランチにもおすすめです。',
    name: '山田 太郎',
    role: 'Regular Customer',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Japanese%20man%20with%20friendly%20expression%20and%20glasses%2C%20casual%20smart%20style%2C%20neutral%20warm%20background%2C%20soft%20natural%20lighting%2C%20vintage%20film%20photography%20style%20with%20subtle%20sepia%20tones&width=100&height=100&seq=avatar-03&orientation=squarish',
  },
  {
    id: 4,
    rating: 5,
    title: 'シェイクが濃厚で美味',
    body: '手作りのミルクシェイクは本当に濃厚で、昔ながらの味わい。ホットドッグとのセットがおすすめです。',
    name: '鈴木 花子',
    role: 'Local Guide',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20middle%20aged%20Japanese%20woman%20with%20kind%20warm%20smile%2C%20elegant%20casual%20style%2C%20neutral%20cream%20background%2C%20soft%20natural%20lighting%2C%20vintage%20film%20photography%20style%20with%20warm%20sepia%20tones&width=100&height=100&seq=avatar-04&orientation=squarish',
  },
  {
    id: 5,
    rating: 5,
    title: '家族で楽しめる空間',
    body: 'キッズメニューもあり、家族みんなで楽しめます。カウンター席も雰囲気があって、一人でも入りやすい。',
    name: '伊藤 誠',
    role: 'Family Customer',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20friendly%20Japanese%20father%20in%20his%20thirties%20with%20warm%20genuine%20smile%2C%20casual%20clothing%2C%20neutral%20warm%20background%2C%20soft%20natural%20lighting%2C%20vintage%20film%20photography%20style%20with%20subtle%20warm%20tones&width=100&height=100&seq=avatar-05&orientation=squarish',
  },
  {
    id: 6,
    rating: 4,
    title: 'インスタ映え間違いなし',
    body: '内装が本当に可愛くて、どこを撮っても映えます。フードも見た目が華やかで、SNSに載せたくなります。',
    name: '高橋 ゆい',
    role: 'Instagrammer',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20stylish%20young%20Japanese%20woman%20in%20her%20twenties%20with%20trendy%20fashion%20and%20confident%20smile%2C%20neutral%20warm%20background%2C%20soft%20natural%20lighting%2C%20vintage%20film%20photography%20style%20with%20subtle%20warm%20tones&width=100&height=100&seq=avatar-06&orientation=squarish',
  },
];

export const businessHours = [
  { day: '月曜日', hours: '7:00 - 22:00' },
  { day: '火曜日', hours: '7:00 - 22:00' },
  { day: '水曜日', hours: '7:00 - 22:00' },
  { day: '木曜日', hours: '7:00 - 22:00' },
  { day: '金曜日', hours: '7:00 - 23:00' },
  { day: '土曜日', hours: '7:00 - 23:00' },
  { day: '日曜日', hours: '7:00 - 22:00' },
];